module.exports = __webpack_public_path__ + "static/img/Bachelor_010401.b9eb27b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010401.jpg
// module id = 159
// module chunks = 0